import { ProductType } from "./product-type.model"

// Define status codes for both recordings and station approvals
export type RecordingStatus = 0 | 1 | 2 // 0: Pending, 1: Approved, 2: Declined

// Interface for station approval entries
export interface StationApproval {
  id?: number
  recording_id?: number
  station_id: number
  approval_status: RecordingStatus // 0=pending, 1=approved, 2=rejected
  approved_by?: number
  approved_at?: string
  created_at?: string
  updated_at?: string
  station_name?: string
  station_call_sign?: string
}

// Interface for main recording object
export interface Recording {
  id?: number
  recording_id: number
  station_id: number
  name: string
  uploaderid: number
  audiofilepath?: string
  status: RecordingStatus
  talentid?: number
  producttype?: number
  audiolength?: number
  created_at?: string
  updated_at?: string
  cloudfront_url?: string
  audio_url?: string
  presigned_url?: string
  station_approvals?: StationApproval[]
  station_approval?: StationApproval
  submitted_stations?: number[]
  station_name?: string
  station_call_sign?: string
  approval_status: RecordingStatus
  /** Embedded by GET /audioRecordings; empty array when none assigned. */
  product_types?: ProductType[]
  is_preemptible_promo?: boolean
  /** True when any station has approved this recording. */
  is_approved_anywhere?: boolean
  station_owner_id?: number
  /** This station's declined row was replaced by a new corrected recording. */
  is_superseded?: boolean
  /** Set on the new recording created by resubmit_new. Messages were copied onto this id. */
  resubmitted_from_recording_id?: number | null
}

/** Backend cap for a decline reason and any later thread message. */
export const RECORDING_MESSAGE_MAX_CHARS = 5000

/** A station's decline reason, or an ordinary reply from either side. */
export type RecordingMessageType = "decline_reason" | "message"

/** One row in GET/POST /audioRecordings/{id}/messages, oldest first. */
export interface RecordingStationMessage {
  id: number
  recording_id: number
  station_id: number
  /** Null after the sender's account was removed; the message itself is kept. */
  sender_user_id: number | null
  sender_role: string
  /** Every decline (including a repeat decline of a corrected recording) is "decline_reason". */
  message_type?: RecordingMessageType
  message_text: string
  created_at: string
}

// Mapping for status → display label
export const RECORDING_STATUS_LABELS: Record<RecordingStatus, string> = {
  0: "Pending",
  1: "Approved",
  2: "Declined",
}

// Mapping for status → CSS class
export const RECORDING_STATUS_CLASS: Record<RecordingStatus, string> = {
  0: "status-pending",
  1: "status-approved",
  2: "status-declined",
}
